import { useCallback, useEffect, useState } from 'react';
import api from '../services/api';

const useProfileOverview = () => {
  const [overview, setOverview] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const response = await api.get('/users/profile');
      setOverview(response.data);
      setError(null);
    } catch (err) {
      console.error('Failed to load profile overview', err);
      setError(err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return {
    overview,
    setOverview,
    loading,
    error,
    refresh,
  };
};

export default useProfileOverview;
